import axios from 'axios';
import { authHeader } from './authservice/auth-header';

const BASE_API = process.env.VUE_APP_BASE_API_URL;

class CctvService {
    list() {
        return axios.get(BASE_API + 'open-cctv', { headers: authHeader() });
    }
    map() {
        return axios.get(BASE_API + 'open-cctv/map', { headers: authHeader() });
    }
    create(data) {
        return axios.post(BASE_API + 'open-cctv', data, { headers: authHeader() });
    }
    update(id, data) {
        return axios.patch(BASE_API + 'open-cctv/'+id, data, { headers: authHeader() });
    }
    delete(id) {
        return axios.delete(BASE_API + 'open-cctv/'+id, { headers: authHeader() });
    }
    detail(id) {
        return axios.get(BASE_API + 'open-cctv/'+id, { headers: authHeader() });
    }
    format() {
        return axios.get(BASE_API + 'open-cctv/download-format', { responseType: 'blob', headers: authHeader() });
    } 
    import(data) {
        return axios.post(BASE_API + 'open-cctv/import', data, { headers: authHeader(true) });
    }
    export() {
        return axios.get(BASE_API + 'open-cctv/export-cctv', {responseType: 'blob',  headers: authHeader() });
    }
}

export default new CctvService();
